import { useState } from 'react';
import { Mail, Phone, User, ArrowRight, Loader2 } from 'lucide-react';
import { contactInfo, offers } from '../mock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Contact = () => {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', offer: 'vitrine', message: ''
  });
  const [status, setStatus] = useState({ type: 'idle', msg: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setStatus({ type: 'idle', msg: '' });

    try {
      const res = await fetch(`${BACKEND_URL}/api/leads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, source: 'contact_form' }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || `HTTP ${res.status}`);
      }
      await res.json();
      setStatus({
        type: 'success',
        msg: 'Merci ! Votre demande a bien été envoyée. Nolan vous recontacte sous 24h.'
      });
      setForm({ name: '', email: '', phone: '', offer: 'vitrine', message: '' });
    } catch (err) {
      console.warn('Contact: submit failed', err);
      setStatus({
        type: 'error',
        msg: "Une erreur est survenue. Réessayez ou contactez Nolan directement au 06 69 47 75 36."
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section">
      <span className="section-eyebrow">Contact</span>
      <h2 className="section-title">
        Parlons de votre <em>projet</em>.
      </h2>
      <p className="section-desc">
        Un site vitrine, une boutique en ligne, ou juste une question ? Écrivez-moi ou appelez-moi directement, je réponds sous 24h.
      </p>

      <div className="contact-wrap">
        <div>
          <div className="contact-info-list">
            <a href={`mailto:${contactInfo.email}`} className="contact-info-item">
              <div className="icon-wrap"><Mail size={20} /></div>
              <div>
                <span className="label">Email</span>
                <span className="value">{contactInfo.email}</span>
              </div>
            </a>
            <a href={`tel:+33669477536`} className="contact-info-item">
              <div className="icon-wrap"><Phone size={20} /></div>
              <div>
                <span className="label">Téléphone</span>
                <span className="value">{contactInfo.phone}</span>
              </div>
            </a>
            <div className="contact-info-item">
              <div className="icon-wrap"><User size={20} /></div>
              <div>
                <span className="label">Votre interlocuteur</span>
                <span className="value">{contactInfo.name}</span>
              </div>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="name">Nom complet</label>
            <input required id="name" name="name" value={form.name} onChange={handleChange} placeholder="Jean Dupont" />
          </div>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input required type="email" id="email" name="email" value={form.email} onChange={handleChange} placeholder="vous@commerce.fr" />
          </div>
          <div className="field">
            <label htmlFor="phone">Téléphone (optionnel)</label>
            <input id="phone" name="phone" value={form.phone} onChange={handleChange} placeholder="06 12 34 56 78" />
          </div>
          <div className="field">
            <label htmlFor="offer">Formule souhaitée</label>
            <select id="offer" name="offer" value={form.offer} onChange={handleChange}>
              {offers.map(o => (
                <option key={o.id} value={o.id}>{o.name} — {o.price}€</option>
              ))}
              <option value="autre">Je ne sais pas encore</option>
            </select>
          </div>
          <div className="field">
            <label htmlFor="message">Votre projet</label>
            <textarea id="message" name="message" value={form.message} onChange={handleChange} placeholder="Parlez-nous de votre commerce et de vos besoins..." />
          </div>

          {status.type === 'success' && (
            <div className="form-success">{status.msg}</div>
          )}
          {status.type === 'error' && (
            <div className="form-error">{status.msg}</div>
          )}

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting
              ? <><Loader2 size={18} className="chat-loader" /> Envoi...</>
              : <>Envoyer ma demande <ArrowRight size={18} /></>}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
